<template>
  <div
    v-if="config.showClaimsFormLink && config.claimsFormLink"
    class="claims-form-link-section"
  >
    <p>
      Already purchased?
    </p>
    <p>
      Claim your gift card
      <a
        :href="config.claimsFormLink"
        target="_blank"
        class="claims-link"
      >
        here
      </a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'claims-form-link',
  inject: ['config'],
};
</script>

<style lang="scss" scoped>
.claims-form-link-section {
  padding: 24px 14px;
  text-align: center;

  @media screen and (min-width: 960px) {
    max-width: 190px;
    border: 1px solid $clr-heather;
    background: $clr-white;
    border-radius: 6px;
    margin-top: 10px;
  }

  &.row-claims-link {
    @media screen and (min-width: 960px) {
      max-width: none;
      border: none;
      background: none;
      border-radius: 0;
      margin-top: 0;
    }

    p {
      display: inline;
    }
  }

  p {
    display: inline;

    @media screen and (min-width: 960px) {
      display: block;
      margin-bottom: 10px;
    }
  }
}

.claims-link {
  text-decoration: underline;
}
</style>
